import ProtectedRoute from "./routes/ProtectedRoute";
import "./App.scss";

// ============ Auth ===============
import AuthComponent from "./pages/authpage/AuthComponent.jsx";
import UserOtp from "./pages/authpage/Otp.jsx";
import ForgetPassword from "./pages/authpage/ForgetPassword.jsx";
import PasswordOtp from "./pages/authpage/PasswordOtp.jsx";
import ResetPassword from "./pages/authpage/ResetPassword.jsx";

// ============ Public ==============
import Maintenance from "./pages/maintenance/Maintenance.jsx";

// ============ Private ==============
import Profile from "./pages/user/profile/Profile.jsx";
import Dashboard from "./pages/user/dashboard/Dashboard.jsx";
import Accounts from "./pages/user/accounts/Accounts.jsx";
import Trades from "./pages/user/accounts/Trades.jsx";
import AccountTypes from "./pages/user/accounts/components/AccountTypes.jsx";
import AccountDetails from "./pages/user/accounts/AccountDetails.jsx";
import Deposit2 from "./pages/user/wallet/deposit/Deposit2.jsx";
import DepositUSDT from "./pages/user/wallet/deposit/components/DepositUSDT.jsx";
import Transfer from "./pages/user/transfer/Transfer.jsx";
import MyTransactions from "./pages/user/transactions/Transactions.jsx";
import Tutorials from "./pages/user/tutorials/Tutorials.jsx";
import Support from "./pages/user/support/Support.jsx";
import ViewTicket from "./pages/user/support/components/ViewTicket.jsx";
import Faq from "./pages/user/faq/Faq.jsx";
import Kyc from "./pages/user/kyc/Kyc.jsx";
// --- IB ---
import IBDashboard from "./pages/ib/ibDashboard/IBDashboard.jsx";
import IBWithdraw from "./pages/ib/wallet/withdraw/Withdraw.jsx";
import IBTeam from "./pages/ib/ibTeam/IBTeam.jsx";
import Transactions from "./pages/ib/transactions/Transactions.jsx";
import IBTree from "./pages/ib/ibTree/IBTree.jsx";
import Trade from "./pages/ib/report/trade/Trade.jsx";
import Earning from "./pages/ib/report/earning/Earning.jsx";
import IBSupport from "./pages/ib/support/Support.jsx";
import PageNotFound from "./pages/pageNotFound/PageNotFound.jsx";
import EmailExpired from "./pages/emailExpired/EmailExpired.jsx";
import { Outlet } from "react-router-dom";
import TermsAndCondition from "./pages/termsAndCondition/TermsAndCondition.jsx";
import ViewIBTicket from "./pages/ib/support/components/ViewIBTicket.jsx";
import LiveAccount from "./pages/ib/liveAccount/LiveAccount.jsx";
import Commission from "./pages/ib/commission/Commission";
import KYCManager from "./pages/ib/kycManager/KYCManager.jsx";
import IBManager from "./pages/ib/iBManager/IBManager.jsx";
import Inbox from "./pages/user/inbox/Inbox.jsx"
import IBInbox from "./pages/ib/inbox/Inbox.jsx"
import CommissionDistribute from "./pages/ib/commissionDistribute/CommissionDistribute.jsx";
import parentTree from "./pages/user/ParentTree/ParentTree.jsx"
import IbDetails from "./pages/ib/iBManager/components/IbDetails.jsx";
import Promotion from "./pages/ib/promotion/promotion.jsx"
import Promotionview from "./pages/ib/promotion/promotionview.js"
import Logs from "./pages/user/logs/logs.jsx"
import PerfectMoney from "./pages/user/payment/PerfectMoney.jsx";
import Payment from "./pages/user/payment/payment.jsx"
import AdminLogin from "./pages/authpage/AdminLogin.jsx";
import Download from "./pages/user/download/Download.jsx";
import WithdrawalReport from "./pages/user/Reports/withdrawalReport.jsx"
import TransferReport from "./pages/user/Reports/transferReport.jsx"
import DepositReport from "./pages/user/Reports/depositReport.jsx";
import WalletDeposit from "./pages/user/wallet/deposit/components/WalletDeposit.jsx";
import UserProfile from "./pages/user/profile/UserProfile.jsx";
import Withdraw2 from "./pages/user/wallet/withdraw/Withdraw2.jsx";
import Support2 from "./pages/user/support/components/Support2.jsx";
import ViewTicket2 from "./pages/user/support/components/ViewTicket2.jsx";
import IbApproveList from "./pages/ib/ibConfig/IbApproveList.jsx";
import IbConfig from "./pages/ib/ibConfig/IbConfig.jsx";
import LpDashboard from "./pages/lp/LpDashboard.jsx";
import Education from "./pages/user/education/Education.jsx";
import EducationMaterialDetail from "./pages/user/education/EducationMaterialDetail.jsx";
import EducationSection from "./pages/user/education/EducationSection.jsx";

const IbRoutes = [
  { path: "dashboard", type: "private", component: IBDashboard, ib: "ib", title: "IB Dashboard", },
  { path: "live_account", type: "private", component: LiveAccount, ib: "ib", title: "Live Account", },
  { path: "kyc_manager", type: "private", component: KYCManager, ib: "ib", title: "KYC Manager", },
  { path: "ib_manager", type: "private", component: IBManager, ib: "ib", title: "IB Manager", },
  { path: "ib_details/:id", type: "private", component: IbDetails, ib: "ib", title: "IB Details", parent: [{ title: 'IB Manager', path: '/ib/ib_manager?filter=Approved' }] },
  { path: "ib_details/:type/:id", type: "private", component: IbApproveList, ib: "ib", title: "Approved AC Type", parent: [{ title: 'IB Manager', path: '/ib/ib_manager?filter=Approved' }] },
  { path: "ib_config/:type/:id/:planId", type: "private", component: IbConfig, title: "IB Config", parent: [{ title: 'IB Manager', path: '/ib_manager?filter=Pending' }] },
  { path: "withdraw", type: "private", component: IBWithdraw, ib: "ib", title: "IB Withdraw", },
  { path: "my_trader_team", type: "private", component: IBTeam, ib: "ib", title: "My Trader Team", },
  { path: "commission", type: "private", component: Commission, ib: "ib", title: "IB Commission", },
  { path: "transactions", type: "private", component: Transactions, ib: "ib", title: "IB", },
  { path: "tree", type: "private", component: IBTree, ib: "ib", title: "IB Tree", },
  { path: "trade_sub_report", type: "private", component: Trade, ib: "ib", title: "IB", },
  { path: "my_earning_report", type: "private", component: Earning, ib: "ib", title: "IB", },
  { path: "support", type: "private", component: IBSupport, ib: "ib", title: "IB Support", },
  { path: "inbox", type: "private", component: IBInbox, ib: "ib", title: "IB Inbox", },
  { path: "commission_distribute", type: "private", component: CommissionDistribute, ib: "ib", title: "Commission Distribution", },
  { path: "promotion", type: "private", component: Promotion, ib: "ib", title: "Promotion", },
  { path: "view_ticket/:ticketId", type: "private", component: ViewIBTicket, ib: "ib", title: "IB Support Ticket", },
];

const initialRoutes = [
  // ============ Auth ===============
  { path: "/", type: "auth", component: AuthComponent },
  { path: "otp", type: "auth", component: UserOtp },
  { path: "forget_password", type: "auth", component: ForgetPassword },
  { path: "password_otp_verification", type: "auth", component: PasswordOtp },
  { path: "reset_password", type: "auth", component: ResetPassword },

  // ============ Public =============
  { path: "maintenance", type: "public", component: Maintenance },
  { path: "promotionkit/:kitId", type: "public", component: Promotionview },
  { path: "emailexpired", type: "public", component: EmailExpired },
  { path: "*", type: "public", component: PageNotFound },
  { path: "/adminlogin", type: "public", component: AdminLogin },
  { path: "terms_&_conditions", type: "public", component: TermsAndCondition, title: "Terms & Conditions", },
  // ============ Private ==============
  { path: "dashboard", type: "private", component: Dashboard, title: "Dashboard", },

  { path: "lp_dashboard", type: "private", component: LpDashboard, title: "Dashboard", },

  { path: "accounts", type: "private", component: Accounts, title: "Accounts" },
  { path: "trades/:loginId", type: "private", component: Trades, title: "Trades", parent: [{ title: 'Accounts', path: '/accounts' }] },
  { path: "account", type: "private", component: AccountTypes, title: "Account Types", parent: [{ title: 'Accounts', path: '/accounts' }] },
  { path: "accounts/:loginId", type: "private", component: AccountDetails, title: "Account Details", parent: [{ title: 'Accounts', path: '/accounts' }] },
  { path: "deposit", type: "private", component: Deposit2, title: "Deposit" },
  { path: "walletdeposit", type: "private", component: WalletDeposit, title: "Deposit" },
  { path: "profile", type: "private", component: UserProfile, title: "Profile", },
  { path: "inbox", type: "private", component: Inbox, title: "Inbox" },
  { path: "deposit_usdt/:id", type: "private", component: DepositUSDT, title: "Deposit USDT", parent: [{ title: 'Deposit', path: '/deposit' }] },
  { path: "perent_tree", type: "private", component: parentTree, title: "perent_tree" },
  { path: "withdraw", type: "private", component: Withdraw2, title: "Withdraw" },
  { path: "transfer", type: "private", component: Transfer, title: "Transfer" },
  { path: "my_transaction", type: "private", component: MyTransactions, title: "My Transaction", },
  { path: "logs", type: "private", component: Logs, title: "Logs", },
  { path: "tutorials", type: "kyc", component: Tutorials, title: "Tutorials" },
  { path: "support", type: "kyc", component: Support, title: "Support" },
  { path: "support2", type: "kyc", component: Support2, title: "Support" },
  { path: "perfectMoney", type: "public", component: PerfectMoney },
  { path: "payment/:id", type: "public", component: Payment },
  { path: "view_ticket/:ticketId", type: "kyc", component: ViewTicket, title: "Support Ticket", parent: [{ title: 'Support', path: '/support' }] },
  { path: "view_ticket2/:ticketId", type: "kyc", component: ViewTicket2, title: "Support Ticket", parent: [{ title: 'Support', path: '/support' }] },
  { path: "faq", type: "kyc", component: Faq, title: "Faq" },
  { path: "download", type: "kyc", component: Download, title: "Download Terminal" },
  { path: "kyc", type: "kyc", component: Kyc, title: "KYC" },
  { path: "education", type: "kyc", component: Education, title: "Education" },
  { path: "education/section/:sectionId", type: "kyc", component: EducationSection, title: "Section", parent: [{ title: "Education", path: "/education" }] },
  { path: "education/:materialId", type: "kyc", component: EducationMaterialDetail, title: "Education Material", parent: [{ title: "Education", path: "/education" }] },
  // --- IB ---
  { path: "ib", type: "private", component: Outlet, children: IbRoutes, ib: "parent", },
  { path: "withdrawal_Report", type: "private", component: WithdrawalReport, title: "Withdrawal Report" },
  { path: "transfer_Report", type: "private", component: TransferReport, title: "Transfer Report" },
  { path: "deposit_Report", type: "private", component: DepositReport, title: "Deposit Report" },
];

const generateRoutes = (routes) => {
  return routes.map(({ type, component: Component, children, ib, ...rest }) => {
    return {
      element: (
        <ProtectedRoute type={type} {...rest} ib={ib}>
          <Component />
        </ProtectedRoute>
      ),
      children: children?.length ? generateRoutes(children) : null,
      ...rest,
    };
  });
};

const AppWrapper = generateRoutes(initialRoutes);

export default AppWrapper;
